import moment, { Moment } from 'moment';

export class DateTools {

  static dateWithDayOffset(value: number): Date {
    return moment().utc().add(value, 'days').toDate();
  }

  static dateWithMonthOffset(value: number): Date {
    return moment().utc().add(value, 'months').toDate();
  }

  static dateWithYearOffset(value: number): Date {
    return moment().utc().add(value, 'years').toDate();
  }

  static dateCurrent(): Date {
    return new Date();
  }

  static copyDateOrNull(it: Date): Date {
    return it == null ? null : new Date(it.getTime());
  }

  static fromDtoDateOrNull(it: Date): Date {
    return it == null ? null : moment(it).utc().toDate();
  }

  static combineDateAndTimeUtc(date: Moment, time: string | null | undefined): Moment {
    const combined = date.clone();
    if (time) {
      const [hours, minutes] = time.split(':').map(Number);
      combined.set({ hour: hours, minute: minutes, second: 0, millisecond: 0 });
    }
    return combined;
  }

  static combineDateAndTimeLocal(date: Moment, time: string | null | undefined): Moment {
    const [hours, minutes] = (time || '00:00').split(':').map(Number);

    // Rebuild as a fresh LOCAL moment from the displayed calendar date + typed time,
    // regardless of whether `date` itself is a UTC-mode or local-mode moment.
    // This guarantees a correct local -> UTC conversion when `.toDate().toISOString()`
    // is called later.
    return moment({
      year: date.year(),
      month: date.month(),
      date: date.date(),
      hour: hours,
      minute: minutes,
      second: 0,
      millisecond: 0,
    });
  }
}
